import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import {ProcessFlowStepType} from "~/enums/processFlowStepType"
import {IGenerateDocumentV2Step, IProcessFlowVariable} from '~/interfaces/processFlowInterfaces'
import ProcessFlowVariable from "~/models/processFlows/processFlowVariable"
import IterationStep from "~/models/processFlows/steps/iterationStep"
import ProcessFlow from "~/models/processFlows/processFlow"
import ProcessFlowGenerateDocumentV2StepValidation from "~/models/navigableValidations/processFlowGenerateDocumentV2StepValidation"

export class ProcessFlowGenerateDocumentV2Step extends ProcessFlowStep implements IGenerateDocumentV2Step {
  step_type: ProcessFlowStepType.GenerateDocumentV2
  destination_variable_client_id: string;
  source_variable_client_id: string;
  //******************** VALIDATABLE ********************//
  _validation: ProcessFlowGenerateDocumentV2StepValidation = new ProcessFlowGenerateDocumentV2StepValidation(this);

  constructor(parent: ProcessFlow | IterationStep, options?) {
    super(parent, options)
    // this.defineProperty<this>('certificate_id', null)
    this.defineProperty<this>('source_variable_client_id', null)
    this.defineProperty<this>('destination_variable_client_id', null)
  }

  //******************** VALIDATABLE END ********************//

  /**
   * For common process flow step interface
   */
  get destinationVariable(): IProcessFlowVariable {
    return this.outputVariable
  }

  get destinationVariableClientId(): string {
    return this.destination_variable_client_id
  }

  set destinationVariableClientId(val: string) {
    this.destination_variable_client_id = val
  }

  get sourceVariable(): IProcessFlowVariable {
    return this.inputVariable
  }

  get sourceVariableClientId(): string {
    return this.source_variable_client_id
  }

  set sourceVariableClientId(val: string) {
    this.source_variable_client_id = val
  }

  // common interface end

  get document(): { title: string } {
    if (!this.sourceVariable?.isVariableDocumentDynamicInput()) return

    return this.sourceVariable.referenceModel
  }

  get defaultTitle(): string {
    return `Generate ${this.document?.title || ""} Document`
  }

  get hasValidDestination(): boolean {
    return Boolean(this.destinationVariable)
  }

  get hasValidSource(): boolean {
    return Boolean(this.sourceVariable)
  }

  /**
   * The variable to output the document to
   * @private
   */
  private get outputVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.destinationVariableClientId)
  }

  /**
   * The variable containing the input map
   * @private
   */
  private get inputVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.sourceVariableClientId)
  }
}